import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { LogService } from './log.service';
import { MessagesService } from './messages.service';
import { CommonService } from './common.service';
import { CacheService } from './cache.service';
import { Observable } from 'rxjs/Observable';
import { tap, catchError } from 'rxjs/operators';
import { PageOption } from '../models/common/pageOption';
import { Expense } from '../models/expenses/expense';
import { RequestResult } from '../models/common/requestResult';
import { ExpenseFilter } from '../models/expenses/expenseFilter';
import { PageOptionResult } from '../models/common/pageOptionResult';
import { ErrorCollection } from '../models/common/errorCollection';

@Injectable()
export class ExpenseService {
	private origin: string = environment.API_BASE_URL;

	constructor(
		private _http: HttpClient,
		private _logService: LogService,
		private _messagesService: MessagesService,
		private _common: CommonService,
		private _cacheService: CacheService
	) { }

	getExpense(id: string): Observable<Expense> {
		return this._http.get<Expense>(`${this.origin}/api/expenses/${id}`)
			.pipe(
				tap(x => this.log(`getExpense: id=${id}`)),
				catchError(this._logService.handleError<Expense>('getExpense'))
			);
	}

	getExpensesList(filter: PageOption<ExpenseFilter>): Observable<PageOptionResult<Expense>> {
		let param = this._common.objectToQueryParam(filter);
		return this._http.get<PageOptionResult<Expense>>(`${this.origin}/api/expenses/${param}`)
			.pipe(
				tap(x => this.log(`getExpensesList param = ${param}`)),
				catchError(this._logService.handleError<PageOptionResult<Expense>>('getExpensesList'))
			);
	}

	addExpense(expense: Expense): Observable<RequestResult<Expense>> {
		return this._http.post<RequestResult<Expense>>(`${this.origin}/api/expenses`, JSON.stringify(expense))
			.pipe(
				tap(x => this.log(`addExpense: id=${expense.id}`)),
				catchError(this._logService.handleError<RequestResult<Expense>>('addExpense'))
			);
	}

	updateExpense(expense: Expense): Observable<RequestResult<Expense>> {
		return this._http.put<RequestResult<Expense>>(`${this.origin}/api/expenses/${expense.id}`, JSON.stringify(expense))
			.pipe(
				tap(x => this.log(`updateExpense: id=${expense.id}`)),
				catchError(this._logService.handleError<RequestResult<Expense>>('updateExpense'))
			);
	}

	deleteExpense(id: number): Observable<ErrorCollection> {
		return this._http.delete<ErrorCollection>(`${this.origin}/api/expenses/${id}`)
			.pipe(
				tap(x => this.log(`deleteExpense: id=${id}`)),
				catchError(this._logService.handleError<ErrorCollection>('deleteExpense'))
			);
	}

	private log(message: string) {
		this._messagesService.add('ExpenseService: ' + message);
	}
}



// WEBPACK FOOTER //
// ./src/app/services/expense.service.ts